import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
export function ViewCube(world) {
    const cc = document.getElementById("cube-scene");
    const s = new THREE.Scene();
    const cca = new THREE.PerspectiveCamera(45, 1, 0.1, 10);
    let materials = [];
    let texts = ["ZPRAVA", "ZLEVA", "SHORA", "ZDOLA", "ZEPŘEDU", "ZEZADU"];
    let textureLoader = new THREE.TextureLoader();
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    let size = 200;
    canvas.width = size;
    canvas.height = size;
    ctx.font = 'bold 36px "Overpass", Arial';
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";
    let mainColor = "#fff";
    let otherColor = "#ccc";
    let bg = ctx.createLinearGradient(0, 0, 0, size);
    bg.addColorStop(0, mainColor);
    bg.addColorStop(1, otherColor);
    for (let i = 0; i < 6; i++) {
      if (texts[i] === "TOP") {
        ctx.fillStyle = mainColor;
      } else if (texts[i] === "BOTTOM") {
        ctx.fillStyle = otherColor;
      } else {
        ctx.fillStyle = bg;
      }
      ctx.fillRect(0, 0, size, size);
      ctx.strokeStyle = "#aaa";
      ctx.lineWidth = 2;
      ctx.strokeRect(0, 0, size, size);
      ctx.fillStyle = "#000";
      ctx.fillText(texts[i], size / 2, size / 2);
      materials[i] = new THREE.MeshBasicMaterial({
        map: textureLoader.load(canvas.toDataURL()),
      });
    }
    let ps = [];
    let planeMaterial = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      color: 0x00c0ff,
      transparent: true,
      opacity: 0,
      depthTest: false,
    });
    let planeSize = 0.7;
    let planeGeometry = new THREE.PlaneGeometry(planeSize, planeSize);
    let edgeSize = 0.5;
    let edgeGeometry = new THREE.PlaneGeometry(edgeSize, edgeSize);
    let a = 0.51;
  
    let createPlane = (position, rotation) => {
      let plane = new THREE.Mesh(edgeGeometry, planeMaterial.clone());
      plane.position.copy(position);
      plane.rotation.copy(rotation);
      s.add(plane);
      ps.push(plane);
    };
    
    // Function to calculate position and rotation for the planes on each edge
    let calculatePlanePosition = (x, y, z, rotX, rotY, rotZ) => {
      let position = new THREE.Vector3(x, y, z);
      let rotation = new THREE.Euler(rotX, rotY, rotZ);
      return { position, rotation };
    };
    
  
    let plane1 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane1.position.z = a;
    s.add(plane1);
    ps.push(plane1);
    let plane2 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane2.position.z = -a;
    s.add(plane2);
    ps.push(plane2);
    let plane3 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane3.rotation.y = Math.PI / 2;
    plane3.position.x = a;
    s.add(plane3);
    ps.push(plane3);
    let plane4 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane4.rotation.y = Math.PI / 2;
    plane4.position.x = -a;
    s.add(plane4);
    ps.push(plane4);
    let plane5 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane5.rotation.x = Math.PI / 2;
    plane5.position.y = a;
    s.add(plane5);
    ps.push(plane5);
    let plane6 = new THREE.Mesh(planeGeometry, planeMaterial.clone());
    plane6.rotation.x = Math.PI / 2;
    plane6.position.y = -a;
    s.add(plane6);
    ps.push(plane6);
  
    let planePositions = [
      // edges
      calculatePlanePosition(a, 0, a, 0, Math.PI / 4, 0), 
      calculatePlanePosition(-a, 0, a, 0, -Math.PI / 4, 0), 
      calculatePlanePosition(a, 0, -a, 0, -Math.PI / 4, 0), 
      calculatePlanePosition(-a, 0, -a, 0, Math.PI / 4, 0), 
      calculatePlanePosition(a, a, 0, Math.PI/2, -Math.PI / 4, 0), 
      calculatePlanePosition(-a, a, 0, Math.PI/2, Math.PI / 4, 0), 
      calculatePlanePosition(a, -a, 0, -Math.PI / 2, -Math.PI / 4, 0), 
      calculatePlanePosition(-a, -a, 0, -Math.PI / 2, Math.PI / 4, 0), 
      calculatePlanePosition(0, a, a, -Math.PI / 4, 0, 0), 
      calculatePlanePosition(0, -a, a, Math.PI / 4, 0, 0), 
      calculatePlanePosition(0, a, -a, Math.PI / 4, 0, 0), 
      calculatePlanePosition(0, -a, -a, -Math.PI / 4, 0, 0), 
      //corners
      calculatePlanePosition(a, a, a, -Math.PI / 4, Math.PI / 4, Math.PI / 4), 
      calculatePlanePosition(-a, a, a, -Math.PI / 4, -Math.PI / 4, -Math.PI / 4), 
      calculatePlanePosition(a, -a, a, Math.PI / 4, Math.PI / 4, Math.PI / 4),
      calculatePlanePosition(-a, -a, a, Math.PI / 4, -Math.PI / 4, -Math.PI / 4), 
      calculatePlanePosition(a, a, -a, Math.PI / 4, -Math.PI / 4, Math.PI / 4),
      calculatePlanePosition(-a, a, -a, Math.PI / 4, Math.PI / 4, -Math.PI / 4), 
      calculatePlanePosition(a, -a, -a, -Math.PI / 4, -Math.PI / 4, Math.PI / 4),
      calculatePlanePosition(-a, -a, -a, -Math.PI / 4, Math.PI / 4, -Math.PI / 4),
    ];
  
    // Create planes on each edge of the cube
    for (let i = 0; i < planePositions.length; i++) {
      createPlane(planePositions[i].position, planePositions[i].rotation);
    }
  
    let groundMaterial = new THREE.MeshBasicMaterial({
      color: 0xaaaaaa,
    });
    let groundGeometry = new THREE.PlaneGeometry(1, 1);
    let groundPlane = new THREE.Mesh(groundGeometry, groundMaterial);
    groundPlane.rotation.x = -Math.PI / 2;
    groundPlane.position.y = -0.6;
    s.add(groundPlane);
    let cube = new THREE.Mesh(new THREE.BoxGeometry(1, 1, 1), materials);
    s.add(cube);
    //   _Variables.CubeScene = s;
    const cr = new THREE.WebGLRenderer({
      alpha: true,
      antialias: true,
      preserveDrawingBuffer: true,
    });
    cr.setSize(150, 150);
    cc.appendChild(cr.domElement);
    const ccc = new OrbitControls(cca, cr.domElement);
    ccc.enablePan = false;
    ccc.enableZoom = true;
    ccc.rotateSpeed = 0.5;
    cca.position.set(0, 1, 1);
    ccc.update();
    //   _Variables.CubeControls = ccc;
    console.log(world.camera);
    let c = world.camera.three;
    // viewer.context.getCamera();
    // let ic = viewer.context.getIfcCamera();
    let co = world.camera.controls;
    let ccd = 2.5;
    function getTargetVector(){
      let v = new THREE.Vector3();
      co.getTarget(v);
      return v;
    }
    function updateCubeCamera() {
      if (co) {
        cca.rotation.copy(c.rotation);
        // let tar = co.getTarget();
        let dir = c.position.clone().sub(getTargetVector()).normalize();
        cca.position.copy(dir.multiplyScalar(ccd));
      }
    }
    let ap = null;
    cr.domElement.onmousemove = function (evt) {
      if (ap) {
        ap.material.opacity = 0;
        ap.material.needsUpdate = true;
        ap = null;
      }
  
      let x = evt.offsetX;
      let y = evt.offsetY;
      let size = cr.getSize(new THREE.Vector2());
      let mouse = new THREE.Vector2(
        (x / size.width) * 2 - 1,
        (-y / size.height) * 2 + 1
      );
  
      let raycaster = new THREE.Raycaster();
      raycaster.setFromCamera(mouse, cca);
      let intersects = raycaster.intersectObjects(ps.concat(cube));
  
      if (intersects.length > 0 && intersects[0].object !== cube) {
        ap = intersects[0].object;
        ap.material.opacity = 0.2;
        ap.material.needsUpdate = true;
      }
    };
    let op = new THREE.Vector3();
    let np = new THREE.Vector3();
    cr.domElement.onclick = function (evt) {
      cr.domElement.onmousemove(evt);
  
      if (!ap || hm || sp) {
        return false;
      }
  
      op.copy(c.position);
      let d = c.position.clone().sub(getTargetVector()).length();
      np.copy(getTargetVector());
  
      let l = [];
      l.push(ap.position.x, ap.position.y, ap.position.z)
  
      let typ = l.filter((v, i, a) => v === 0).length;
      if (typ === 1)
        d = d / Math.SQRT2;
      else if (typ === 0)
        d = d / Math.sqrt(3);
  
      if (ap.position.x !== 0) {
        np.x += ap.position.x < 0 ? -d : d;
      } 
      if (ap.position.y !== 0) {
        np.y += ap.position.y < 0 ? -d : d;
      } 
      if (ap.position.z !== 0) {
        np.z += ap.position.z < 0 ? -d : d;
      }
  
      /* if (ap.position.x !== 0) {
        np.x += ap.position.x < 0 ? -d : d;
      } else if (ap.position.y !== 0) {
        np.y += ap.position.y < 0 ? -d : d;
      } else if (ap.position.z !== 0) {
        np.z += ap.position.z < 0 ? -d : d;
      } */
      world.camera.controls.setPosition(np.x, np.y, np.z, true);
    };
    var sp = false;
    cr.domElement.onmousedown = function (e) {
      sp = true;
    };
    cr.domElement.onmouseup = function (e) {
      /* if (ap) {
        sp = false;
        return false;
      } */
  
      let d = getTargetVector().distanceTo(c.position.clone());
      let dirCube = cca.position.clone().sub(ccc.target).normalize();
      let targetIFC = getTargetVector();
      var newPos = targetIFC.add(dirCube.multiplyScalar(d));
      console.log(newPos);
      world.camera.controls.setPosition(newPos.x, newPos.y, newPos.z, false);
  
      sp = false;
    };
    let hm = false;
    function antiMoveOnDown(e) {
      hm = false;
    }
    function antiMoveOnMove(e) {
      hm = true;
    }
    window.addEventListener("mousedown", antiMoveOnDown, false);
    window.addEventListener("mousemove", antiMoveOnMove, false);
    window.addEventListener("touchstart", antiMoveOnDown, false);
    window.addEventListener("touchmove", antiMoveOnMove, true);
    function animate() {
      requestAnimationFrame(animate);
  
      if (sp === false) {
        updateCubeCamera();
      }
  
      cr.render(s, cca);
    }
    animate();
  }
  